export const LOCAL_STORAGE_INVISIBLE_EMAILS_KEY = "invisibledEmailIds";

export const LOCAL_STORAGE_FAVORITE_EMAILS_KEY = "favoriteEmailIds";

export const LOCAL_STORAGE_READ_EMAILS_KEY = "readEmails";

export const LOCAL_STORAGE_EMAIL_SEARCH_CONDITIONS_KEY =
  "emailSearchConditions";
